function getContactValidationState(state) {
  return {
    getContactValidationData: state.contactValidation.getContactValidationData,
    getContactValidationError: state.contactValidation.getContactValidationError,
    updatedUserPhones: state.contactValidation.updatedUserPhones,
    updateContactError: state.contactValidation.updateContactError,
    isUpdatedUserPhones: state.contactValidation.isUpdatedUserPhones,
    hasInvalidFormatPhone: state.contactValidation.hasInvalidFormatPhone,
    isLoading: state.contactValidation.isLoading
  };
}

export { getContactValidationState };
